import React, { useMemo } from 'react';

import { LIST_ITEM_HEIGHT } from 'flow/flow-theme';
import { ChatListRow } from './chat-list-rows';
import ChatSessionsListView from './ChatSessionsListView';
import useChatSessionRows from './useChatSessionRows';

type Props = {
    isLoaded: boolean;
};

/** The chat list with an empty search field: chat sessions and nothing else. */
const ChatSessionsUnfilteredList = ({ isLoaded }: Props) => {
    const { rows, emptyStateRow } = useChatSessionRows();

    /* An empty state means there are no chats in the store. Until the first
     * fetch has answered that is not yet news, so rows stand in for the ones
     * on their way and the bubble waits its turn. */
    const isAwaitingFirstChatSessions = !isLoaded && !!emptyStateRow;

    const listRows = useMemo(() => {
        if (isAwaitingFirstChatSessions) {
            const count = Math.ceil(window.innerHeight / LIST_ITEM_HEIGHT);

            return [
                ...rows,
                ...Array.from(
                    { length: count },
                    (_, index): ChatListRow => ({ kind: 'skeleton', index }),
                ),
            ];
        }

        return emptyStateRow ? [...rows, emptyStateRow] : rows;
    }, [rows, emptyStateRow, isAwaitingFirstChatSessions]);

    return <ChatSessionsListView rows={listRows} />;
};

export default ChatSessionsUnfilteredList;
